import { render, staticRenderFns } from "./CancellationServices.vue?vue&type=template&id=74bc0db0&"
import script from "./CancellationServices.vue?vue&type=script&lang=js&"
export * from "./CancellationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bc0db0')) {
      api.createRecord('74bc0db0', component.options)
    } else {
      api.reload('74bc0db0', component.options)
    }
    module.hot.accept("./CancellationServices.vue?vue&type=template&id=74bc0db0&", function () {
      api.rerender('74bc0db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cancellations/CancellationServices.vue"
export default component.exports